import { render, staticRenderFns } from "./use-plugin-dropdown.vue?vue&type=template&id=20ccefab&scoped=true&"
import script from "./use-plugin-dropdown.vue?vue&type=script&lang=js&"
export * from "./use-plugin-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./use-plugin-dropdown.vue?vue&type=style&index=0&id=20ccefab&lang=scss&scoped=true&"
import style1 from "./use-plugin-dropdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ccefab",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
